import { createSlice } from "@reduxjs/toolkit"
import appointmentApiSlice from "services/appointmentService"
import * as _ from "lodash"
import moment from "moment"

export const initialState = {
  appointmentList: [],
  totalCount: 0,
  limit: 1000,
  offset: 0,
  totalCount: 0,
  startdate: moment().format("MM/DD/YYYY"),
  enddate: moment().format("MM/DD/YYYY"),
  shouldFetchNext: true,
  page: 0,
  maxPageTill: 0,
  departmentToFetdh: [],
}

const appointmentSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload
      // state.offset = state.page * state.limit
      // if (state.page > state.maxPageTill) {
      //   state.maxPageTill = action.payload
      //   state.shouldFetchNext = true
      // } else {
      //   state.shouldFetchNext = false
      // }
    },
    // setDates: (state, action) => {
    //     Object.assign(state, initialState);
    //     state.startdate = action.payload.startdate
    //     state.enddate = action.payload.enddate
    //     state.maxPageTill = initialState.maxPageTill;
    //     state.shouldFetchNext = true
    // },
    setDates: (state, action) => {
      state.startdate = action.payload.startdate
      state.enddate = action.payload.enddate
    },
    setDepartment: (state, action) => {
      state.departmentToFetdh = action.payload
    },
    setFetdh: (state, action) => {
      const temp = { ...state }
      Object.assign(state, initialState)
      state.startdate = temp.startdate
      state.enddate = temp.enddate
      state.maxPageTill = initialState.maxPageTill
      state.departmentToFetdh = temp.departmentToFetdh
      state.shouldFetchNext = true
      state.shouldFetchNext = action.payload
    },
    resetState: (state, action) => {
      Object.assign(state, initialState)
    },
    updateAppointment:(state,action)=>{
      const{rating, providers, departments}= action.payload
      const{ratings}=rating;
      
      state.appointmentList=state.appointmentList.map((appointment)=>{
        console.log(appointment, '$$$$appointment')
        return {...appointment, 
          sendButton: ratings[appointment.appointmentid] ? ratings[appointment.appointmentid].messageSent : false, 
          ratingSubmitted: ratings[appointment.appointmentid] ? ratings[appointment.appointmentid].received : false, 
          rating: ratings[appointment.appointmentid] ? ratings[appointment.appointmentid].rating || 0 : 0,
          providerName: providers.find((p)=>p.providerid.toString()===appointment.providerid)?.displayname || 'N/A',
          departmentName: departments.find((d)=>d.departmentid===appointment.departmentid)?.patientdepartmentname || 'N/A'
    }})
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      appointmentApiSlice.endpoints.fetchAppointments.matchFulfilled,
      (state, action) => {
        state.appointmentList = state.appointmentList.concat(
          action.payload.appointments
        )
        state.totalCount = Number(action.payload.totalcount)
        state.shouldFetchNext = false
      }
    )
    builder.addMatcher(
      appointmentApiSlice.endpoints.fetchAppointments.matchRejected,
      (state, action) => {
        state.shouldFetchNext = false
      }
    )
  },
})

export default appointmentSlice.reducer
export const { setPage, setDates, resetState, setDepartment, setFetdh, updateAppointment } =
  appointmentSlice.actions
